import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity, RefreshCw, Eye } from "lucide-react";

export default function AIHumanAnalytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/ai-human/views").then((r) => setData(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const rows = data?.rows || [];
  const max = Math.max(1, ...rows.map((r) => r.views));

  return (
    <div data-testid="admin-aihuman-analytics">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-display font-bold text-2xl flex items-center gap-2">
            <Activity className="w-5 h-5 text-[#00F0FF]" /> AI Human — Ability Views
          </h2>
          <p className="text-sm text-[#94A3B8] mt-1">
            {data ? `${data.total_views.toLocaleString()} total ability views` : "Loading…"} · ranked by popularity
          </p>
        </div>
        <button onClick={load} data-testid="aihuman-analytics-refresh"
          className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-[#00F0FF] border border-white/10 hover:border-[#00F0FF]/40 rounded-lg px-3 py-2 transition">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Refresh
        </button>
      </div>

      <div className="space-y-2.5">
        {rows.map((r, i) => (
          <div key={r.id} data-testid={`aihuman-row-${r.id}`}
            className="card-surface rounded-xl p-4 flex items-center gap-4">
            <span className="font-mono-tech text-sm text-[#64748B] w-6 shrink-0">#{i + 1}</span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-3">
                <span className="font-display font-bold text-white">{r.name}</span>
                <span className="flex items-center gap-1.5 text-sm font-semibold shrink-0" style={{ color: r.color }}>
                  <Eye className="w-4 h-4" /> {r.views.toLocaleString()}
                </span>
              </div>
              <div className="text-xs text-[#94A3B8] mt-0.5">{r.subtitle} · {r.tools} tools</div>
              <div className="mt-2 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
                <div className="h-full rounded-full transition-all" style={{ width: `${(r.views / max) * 100}%`, background: r.color }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
